import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { ProductOverviewRequest } from '../../product-overview/product-overview-request.model';
import { ExpandNodeInfo } from './ui-helper.models';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject} from 'rxjs';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UiHelperService {

  public expandNodeInfo: ExpandNodeInfo = {child_expand: null, parent_expand: false};
  public prodClusterName = ProductOverviewRequest.productCluster.toLowerCase() || '';
  public isBalanceToggleOn: boolean;
  public balanceToggleSubject: Subject<boolean> = new Subject<boolean>();

  constructor(private readonly http: HttpClient) {
    this.isBalanceToggleOn = false;
  }

  public setBalanceToggle(isBalanceToggleOn: boolean) {
    this.isBalanceToggleOn = isBalanceToggleOn;
  }

  public expandNode(fromComponent: any, hierarchyChildren: any[]): ExpandNodeInfo {

    let productClusterIndex;

    if (this.prodClusterName !== '') {
      productClusterIndex = _.findIndex(hierarchyChildren, (node) => {
        return node.data.product.toLowerCase().includes(this.prodClusterName.toLowerCase());
      });
    } else {
      productClusterIndex = -1;
    }

    // Which child node needs to expand [index]
    this.expandNodeInfo.child_expand = productClusterIndex;
    this.expandNodeInfo.parent_expand = (productClusterIndex >= 0);

    if (fromComponent.data.product && fromComponent.data.product.toLowerCase()
      .includes(this.prodClusterName.toLowerCase())) {
      this.expandNodeInfo.parent_expand = true;
    }

    return this.expandNodeInfo;
  }

  public addBusyCursor() {
    document.body.classList.add('busy-cursor');
  }

  public removeBusyCursor() {
    document.body.classList.remove('busy-cursor');
  }

  public toggleBalance() {
    const loggerUrl = `${environment.civServicesBaseURL}click-logger`;
    const headers = this.createHeaders();
    let textBody = '';
    this.isBalanceToggleOn = !this.isBalanceToggleOn;
    this.balanceToggleSubject.next(this.isBalanceToggleOn);

    textBody = this.isBalanceToggleOn ? 'View Saldo/Premie is on.' : 'View Saldo/Premie is off.';
    return this.http.post<any>(loggerUrl, {message: textBody}, { headers });
  }

  public cacheToggleState() {
    const cachingURL = `${environment.civServicesBaseURL}cache-toggle`;
    const headers = this.createHeaders();
    return this.http.post<any>(cachingURL, {
        parametersToken: ProductOverviewRequest.parametersToken, stateOfToggle: this.isBalanceToggleOn,
      },
      { headers });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', ProductOverviewRequest.token);
    headers = headers.append('MFA-Authorization', ProductOverviewRequest.token);
    headers = headers.append('Graph-Authorization', ProductOverviewRequest.graphToken);
    headers = headers.append('Content-type', 'application/json');
    return headers;
  }

}
